import {useEffect} from "react";

const useClickOutside = (ref, callback) => {
    useEffect(() => {
        const handleClick = e => {
            if (!ref.current || ref.current.contains(e.target)) {
                return;
            }
            callback();
        };
        document.addEventListener("click", handleClick);
        return () => {
            document.removeEventListener("click", handleClick);
        };
    }, [ref, callback]);
};

export default useClickOutside;


